import React, { useEffect } from 'react';
import { useEventTracking } from '../hooks/useAnalytics';
import './TermsOfServicePage.css';

const TermsOfServicePage = () => {
  const { trackEvent } = useEventTracking();

  useEffect(() => {
    trackEvent('terms_of_service_page_view', {
      page_title: 'Termini di Servizio',
      page_location: '/terms-of-service',
      page_type: 'legal'
    });
  }, [trackEvent]);

  return (
    <main className="terms-page">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="main-content-container">
          <div className="terms-hero-content">
            <h1 className="terms-hero-title">Termini di Servizio</h1>
            <p className="terms-hero-subtitle">
              Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
            </p>
          </div>
        </div>
      </section>

      {/* Contenuto principale */}
      <section className="terms-content-section">
        <div className="main-content-container">
          <div className="terms-content">
          <h2>1. Introduzione e accettazione</h2>
            <p>Benvenuto/a su <strong>Loverlist</strong> (il  "Servizio"), piattaforma di comparazione prezzi offerta da <strong>Malianta S.r.l.</strong> (la  "Società ",  "noi "), con sede legale in Via Bastione, 98057 Milazzo (ME) – Italia, P. IVA IT10412320961. Accedendo, navigando o utilizzando il Servizio, l’utente (di seguito l’ "Utente " o  "tu ") dichiara di aver letto, compreso e accettato integralmente i presenti Termini di Servizio (i  "Termini "). Se non intendi accettare questi Termini, devi astenerti dall’utilizzare il Servizio.</p>

            <h2>2. Definizioni</h2>
            <ul>
            <li><strong>Servizio</strong>: il sito loverlist.com, relativi sottodomini e applicazioni, nonché le funzionalità di comparazione prezzi, wishlist, price‑alert e newsletter.</li>
            <li><strong>Venditore/i</strong>: terze parti (singoli o aziende) che promuovono prodotti o offerte tramite Loverlist.</li>
            <li><strong>Contenuti</strong>: testi, immagini, dati di prezzo, loghi, marchi, descrizioni di prodotto, link e qualsiasi altra informazione resa disponibile tramite il Servizio.</li>
            <li><strong>Account</strong>: profilo creato dall’Utente per accedere a funzionalità avanzate (ad es. wishlist o price‑alert).</li>
            </ul>

            <h2>3. Descrizione del Servizio</h2>
            <h3>3.1 Funzionamento generale</h3>
            <p>Loverlist consente di:</p>
            <ol>
            <li>cercare e confrontare prodotti offerti da Venditori terzi;</li>
            <li>visualizzare prezzi, caratteristiche e disponibilità secondo dati forniti dai Venditori;</li>
            <li>salvare prodotti in wishlist personali e/o attivare avvisi di prezzo;</li>
            <li>accedere ai link che rinviano ai siti dei Venditori per eventuali acquisti;</li>
            <li>iscriversi alla newsletter per ricevere aggiornamenti su offerte e novità.</li>
            </ol>
            <p>Il Servizio è <strong>gratuito</strong> per gli Utenti. Loverlist non esegue transazioni di vendita né funge da intermediario di pagamento: eventuali acquisti avvengono direttamente sul sito del Venditore.</p>

            <h3>3.2 Neutralità dell’algoritmo</h3>
            <p>Il motore di comparazione seleziona le offerte che meglio rispondono alla query dell’Utente; di default i risultati sono ordinati per prezzo crescente. L’Utente può scegliere altri criteri di ordinamento (ad es. popolarità o prezzo decrescente). La classifica non privilegia deliberatamente alcun Venditore; eventuali offerte sponsorizzate saranno chiaramente etichettate.</p>

            <h3>3.3 Costi e commissioni</h3>
            <p>Pur restando gratuito per gli Utenti, Loverlist può percepire commissioni pubblicitarie o partecipare a programmi di affiliazione con alcuni Venditori. Tali commissioni <strong>non</strong> influenzano la neutralità dei risultati mostrati.</p>

            <h2>4. Idoneità e registrazione dell’Account</h2>
            <p>Puoi navigare su Loverlist senza registrarti. Alcune funzionalità avanzate richiedono la creazione di un Account, riservata a persone:</p>
            <ul>
            <li>di almeno 18 anni, oppure con il consenso di un genitore/tutore;</li>
            <li>legalmente capaci di sottoscrivere contratti vincolanti;</li>
            <li>non precedentemente sospese o rimosse dal Servizio.</li>
            </ul>
            <p>Al momento della registrazione devi fornire dati accurati, completi e aggiornati. Sei responsabile della riservatezza delle credenziali di accesso e di qualsiasi attività svolta tramite il tuo Account.</p>

            <h2>5. Uso consentito e divieti</h2>
            <p>L’Utente si impegna a:</p>
            <ul>
            <li>utilizzare il Servizio esclusivamente per scopi leciti, personali e non commerciali;</li>
            <li>non violare diritti di terzi, incluse proprietà intellettuali o diritti di privacy;</li>
            <li>non caricare, condividere o trasmettere contenuti illeciti, diffamatori, ingannevoli o dannosi;</li>
            <li>non effettuare scraping, data‑mining o accesso automatizzato al di fuori dei limiti indicati nel file <em>robots.txt</em> o senza nostro consenso scritto;</li>
            <li>non utilizzare il Servizio per fare pubblicità a prodotti o marchi propri o di terzi;</li>
            <li>non raccogliere dati personali di altri Utenti senza consenso.</li>
            </ul>

            <h2>6. Contenuti di terzi, offerte sponsorizzate e link esterni</h2>
            <p>Le informazioni visualizzate (prezzi, disponibilità, descrizioni) provengono direttamente dai Venditori o da fonti da essi autorizzate. Non garantiamo che tali dati siano corretti, completi o aggiornati.</p>
            <p>Alcune offerte o contenuti possono essere sponsorizzati o frutto di accordi di affiliazione; in tal caso saranno contrassegnati in modo chiaro.</p>
            <p>I link presenti su Loverlist conducono a siti di terzi fuori dal nostro controllo. Non siamo responsabili per contenuti, politiche o pratiche di tali siti, né per eventuali transazioni da te concluse.</p>

            <h2>7. Proprietà intellettuale</h2>
            <p>Il Servizio, inclusi design, logo, software e banca dati, è di proprietà della Società o dei suoi licenzianti ed è protetto da copyright e altre leggi applicabili. È vietato copiare, riprodurre, distribuire, modificare o creare opere derivate senza previo consenso scritto del titolare dei diritti, salvo gli usi consentiti dalla legge.</p>

            <h2>8. Nessun rapporto contrattuale con i Venditori</h2>
            <p>Utilizzando Loverlist non si instaura alcun rapporto contrattuale tra l’Utente e la Società in merito alla vendita dei prodotti. Qualsiasi contratto di acquisto sorge <strong>esclusivamente</strong> tra Utente e Venditore.</p>

            <h2>9. Nessun consiglio medico o sanitario</h2>
            <p>Pur includendo prodotti per salute o benessere, Loverlist <strong>non fornisce consulenza medica o professionale</strong>. Le informazioni hanno scopo puramente informativo.</p>

            <h2>10. Protezione e sicurezza dei dati personali</h2>
            <p>Trattiamo i dati personali dell’Utente nel rispetto del Regolamento (UE) 2016/679 (GDPR) e della nostra <a href="/privacy-policy" target="_blank" rel="noopener">Informativa Privacy</a>. Adottiamo misure tecniche e organizzative adeguate. L’Utente è tenuto a custodire con cura le proprie credenziali e a segnalarci usi non autorizzati.</p>

            <h2>11. Newsletter e comunicazioni commerciali</h2>
            <p>Con la registrazione alla newsletter acconsenti a ricevere comunicazioni promozionali via e‑mail. Puoi revocare il consenso in qualsiasi momento tramite il link di disiscrizione presente in ogni messaggio.</p>

            <h2>12. Esclusione di garanzie</h2>
            <p>Il Servizio è fornito  "<strong>così com’è</strong> " e  "come disponibile ", senza garanzie di alcun tipo, espresse o implicite.</p>

            <h2>13. Limitazione di responsabilità</h2>
            <p>Nella misura massima consentita dalla legge, la Società non risponderà di danni diretti o indiretti derivanti dall’uso del Servizio.</p>

            <h2>14. Indennizzo</h2>
            <p>L’Utente si impegna a manlevare la Società da qualsiasi pretesa derivante da violazioni dei Termini.</p>

            <h2>15. Sospensione e cessazione</h2>
            <p>Ci riserviamo il diritto di sospendere o chiudere l’Account qualora riscontrassimo violazioni.</p>

            <h2>16. Cessione</h2>
            <p>La Società può cedere i diritti/obblighi derivanti dai presenti Termini senza ulteriore consenso dell’Utente.</p>

            <h2>17. Forza maggiore</h2>
            <p>Nessuna delle parti sarà responsabile per ritardi dovuti a cause di forza maggiore.</p>

            <h2>18. Modifiche ai Termini</h2>
            <p>Potremmo aggiornare i Termini; l’uso continuato del Servizio dopo le modifiche costituisce accettazione.</p>

            <h2>19. Legge applicabile e foro competente</h2>
            <p>I Termini sono regolati dalla legge italiana; foro competente: Messina, salvo diverso foro inderogabile.</p>

            <h2>20. Risoluzione alternativa delle controversie (ADR)</h2>
            <p>Ai sensi dell’art. 14 del Regolamento (UE) 524/2013, l’Utente può utilizzare la piattaforma ODR (<a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener">link</a>).</p>

            <h2>21. Clausola di separabilità</h2>
            <p>Se una disposizione è invalida, le restanti restano efficaci.</p>

            <h2>22. Intero accordo</h2>
            <p>I Termini, con Privacy e Cookie Policy, costituiscono l’intero accordo tra Utente e Società.</p>

            <h2>23. Lingua prevalente</h2>
            <p>I Termini sono redatti in italiano; in caso di incongruenze con traduzioni, prevale la versione italiana.</p>

            <h2>24. Contatti</h2>
            <p>Per domande o chiarimenti: <a href="mailto:legal@loverlist.com">legal@loverlist.com</a> – Malianta S.r.l., Via Bastione, 98057 Milazzo (ME).</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsOfServicePage; 